import { getRgObjectsOfType as r, RG_TYPE as t } from "@project-rouge/rg-core";
import { isDoubleDoor as e } from "../../queries/index3.js";
const g = (o) => r(o, t.Door).filter(e).length;
export {
  g as getDoubleDoorsCount
};
//# sourceMappingURL=index16.js.map
